import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';

export const toggleAgendaPane = action('toggleAgendaPane', () => {
    return addDatapointConfig({ name: 'toggleAgendaPane' });
});
